import { fetchApi } from './api'
import uuid from 'uuid'
import { EventUpdate } from 'src/schemas'
import { formatDoubleQuotes } from './utils'
import { showHud } from './frontend'
// import { formatDoubleQuotes } from './utils'

export const CHANGE_EVENT_FORM = 'CHANGE_EVENT_FORM'
export const RESET_EVENT_FORM = 'RESET_EVENT_FORM'
export const CHANGE_EVENTS_TAB = 'CHANGE_EVENTS_TAB'
export const CHANGE_EVENTS_MODAL = 'CHANGE_EVENTS_MODAL'

export const FETCH_CREATE_EVENT = 'FETCH_CREATE_EVENT'
export const FETCH_CREATE_EVENT_SUCCESS = 'FETCH_CREATE_EVENT_SUCCESS'
export const FETCH_CREATE_EVENT_ERROR = 'FETCH_CREATE_EVENT_ERROR'

export const FETCH_FLYER_DESIGNS = 'FETCH_FLYER_DESIGNS'
export const FETCH_FLYER_DESIGNS_SUCCESS = 'FETCH_FLYER_DESIGNS_SUCCESS'
export const FETCH_FLYER_DESIGNS_ERROR = 'FETCH_FLYER_DESIGNS_ERROR'

export const FETCH_UPLOAD_FLYER = 'FETCH_UPLOAD_FLYER'
export const FETCH_UPLOAD_FLYER_SUCCESS = 'FETCH_UPLOAD_FLYER_SUCCESS'
export const FETCH_UPLOAD_FLYER_ERROR = 'FETCH_UPLOAD_FLYER_ERROR'

export const FETCH_ME_COMMUNITIES = 'FETCH_ME_COMMUNITIES'
export const FETCH_ME_COMMUNITIES_SUCCESS = 'FETCH_ME_COMMUNITIES_SUCCESS'
export const FETCH_ME_COMMUNITIES_ERROR = 'FETCH_ME_COMMUNITIES_ERROR'

export const ACTIVATE_EVENT = 'ACTIVATE_EVENT'
export const ACTIVATE_EVENT_SUCCESS = 'ACTIVATE_EVENT_SUCCESS'
export const ACTIVATE_EVENT_ERROR = 'ACTIVATE_EVENT_ERROR'

export const SEND_UPDATE_EVENT = 'SEND_UPDATE_EVENT'
export const SEND_UPDATE_EVENT_SUCCESS = 'SEND_UPDATE_EVENT_SUCCESS'
export const SEND_UPDATE_EVENT_ERROR = 'SEND_UPDATE_EVENT_ERROR'

export const DELETE_EVENT = 'DELETE_EVENT'
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS'
export const DELETE_EVENT_ERROR = 'DELETE_EVENT_ERROR'

export const CLONE_EVENT = 'CLONE_EVENT'
export const CLONE_EVENT_SUCCESS = 'CLONE_EVENT_SUCCESS'
export const CLONE_EVENT_ERROR = 'CLONE_EVENT_ERROR'

export const ARCHIVE_EVENT = 'ARCHIVE_EVENT'
export const ARCHIVE_EVENT_SUCCESS = 'ARCHIVE_EVENT_SUCCESS'
export const ARCHIVE_EVENT_ERROR = 'ARCHIVE_EVENT_ERROR'

export const ARCHIVE_TICKET_TYPE = 'ARCHIVE_TICKET_TYPE'
export const ARCHIVE_TICKET_TYPE_SUCCESS = 'ARCHIVE_TICKET_TYPE_SUCCESS'
export const ARCHIVE_TICKET_TYPE_ERROR = 'ARCHIVE_TICKET_TYPE_ERROR'

export const CREATE_TICKET_TYPE = 'CREATE_TICKET_TYPE'
export const CREATE_TICKET_TYPE_SUCCESS = 'CREATE_TICKET_TYPE_SUCCESS'
export const CREATE_TICKET_TYPE_ERROR = 'CREATE_TICKET_TYPE_ERROR'

export function changeEventForm(params) {
  return { type: CHANGE_EVENT_FORM, params }
}

export function resetEventForm() {
  return { type: RESET_EVENT_FORM }
}

export function changeEventsTab(params) {
  return { type: CHANGE_EVENTS_TAB, value: params }
}

export function changeEventsModal(params) {
  return { type: CHANGE_EVENTS_MODAL, value: params }
}

export function fetchCreateEvent({ eventId, eventForm, onSuccessCallback, onErrorCallback }) {
  return fetchApi({
    requestType: FETCH_CREATE_EVENT,
    successType: FETCH_CREATE_EVENT_SUCCESS,
    errorType: FETCH_CREATE_EVENT_ERROR,
    route: `/events/${eventId || uuid.v4()}`,
    options: {
      method: eventId ? 'PATCH' : 'PUT',
      body: JSON.stringify({ event: eventForm })
    },
    onSuccessCallback,
    onErrorCallback
  })
}

export function deleteEvent({ eventId, onSuccessCallback }) {
  return fetchApi({
    requestType: DELETE_EVENT,
    successType: DELETE_EVENT_SUCCESS,
    errorType: DELETE_EVENT_ERROR,
    route: `/events/${eventId}`,
    options: {
      method: 'DELETE'
    },
    onSuccessCallback
  })
}

export function cloneEvent({ eventId, onSuccessCallback }) {
  return fetchApi({
    requestType: CLONE_EVENT,
    successType: CLONE_EVENT_SUCCESS,
    errorType: CLONE_EVENT_ERROR,
    route: `/events/${eventId}/clone`,
    options: {
      method: 'POST'
    },
    onSuccessCallback
  })
}

export function fetchFlyerDesigns() {
  return fetchApi({
    requestType: FETCH_FLYER_DESIGNS,
    successType: FETCH_FLYER_DESIGNS_SUCCESS,
    errorType: FETCH_FLYER_DESIGNS_ERROR,
    route: '/graphql',
    options: {
      method: 'POST',
      body: JSON.stringify({
        query: `{
          flyer_designs {
            active_galleries {
              flyer_designs {
                design_number
                design_slug
                version
                gallery_name
                image_bg_slug
                video_bg_slug
                filter_slug
                image_overlay_slug
                video_overlay_slug
                layout_slug
                status
                layout_properties {
                  slug
                  color
                  font
                  all_caps
                }
                default_type
                bg_crop_area {
                  top
                  right
                  bottom
                  left
                }
              }
            }
          }
        }`
      })
    }
  })
}

export function fetchUploadFlyer({
  eventId,
  design_number,
  customBgDataURL,
  onSuccessCallback,
  onErrorCallback
}) {
  const requestParams = {
    image_flyer: {
      design_number,
      image_upload_attributes: {
        mimetype: 'image/png',
        id: uuid.v4()
      }
    }
  }
  if (customBgDataURL) {
    requestParams.image_flyer.image_bg_upload_attributes = {
      mimetype: 'image/png',
      id: uuid.v4()
    }
  }

  return fetchApi({
    requestType: FETCH_UPLOAD_FLYER,
    successType: FETCH_UPLOAD_FLYER_SUCCESS,
    errorType: FETCH_UPLOAD_FLYER_ERROR,
    route: `/events/${eventId}/image_flyers`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestParams)
    },
    onSuccessCallback,
    onErrorCallback,
    errorActions: [
      showHud('error', "Hmm... something's not working. Please wait a few moments and try again")
    ]
  })
}

export function fetchMeWithCommunities() {
  return fetchApi({
    requestType: FETCH_ME_COMMUNITIES,
    successType: FETCH_ME_COMMUNITIES_SUCCESS,
    errorType: FETCH_ME_COMMUNITIES_ERROR,
    route: '/graphql2',
    options: {
      method: 'POST',
      body: JSON.stringify({
        query: `{
          me {
            id
            communities {
              id
              name
              my_community_member {
                role
              }
            }
          }
        }`
      })
    }
  })
}

export function activateEvent({ eventId, count, successActions = [] }) {
  return fetchApi({
    requestType: ACTIVATE_EVENT,
    successType: ACTIVATE_EVENT_SUCCESS,
    errorType: ACTIVATE_EVENT_ERROR,
    payload: { eventId },
    route: `/events/${eventId}/activate`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        count
      })
    },
    successActions
  })
}

export function sendUpdateEvent({ eventId, content, recipient_states, successActions }) {
  return fetchApi({
    requestType: SEND_UPDATE_EVENT,
    successType: SEND_UPDATE_EVENT_SUCCESS,
    errorType: SEND_UPDATE_EVENT_ERROR,
    schema: {
      event_update: EventUpdate
    },
    route: `/events/${eventId}/updates`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        content,
        recipient_states
      })
    },
    successActions
  })
}

export function archiveEvent({ eventId, onSuccessCallback }) {
  return fetchApi({
    requestType: ARCHIVE_EVENT,
    successType: ARCHIVE_EVENT_SUCCESS,
    errorType: ARCHIVE_EVENT_ERROR,
    route: `/graphql`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        query: `
          mutation {
            archive_event(event_id:"${eventId}") {
              successful
              human_readable_error
              result {
                archived_at
              }
            }
          }
        `
      })
    },
    onSuccessCallback
  })
}

export function archiveTicketType(ticketId) {
  return fetchApi({
    requestType: ARCHIVE_TICKET_TYPE,
    successType: ARCHIVE_TICKET_TYPE_SUCCESS,
    errorType: ARCHIVE_TICKET_TYPE_ERROR,
    route: `/graphql2`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        query: `
          mutation {
            archive_ticket_type(id:"${ticketId}") {
              id
            }
          }
        `
      })
    }
  })
}

export function createTicketType(eventId) {
  return fetchApi({
    requestType: CREATE_TICKET_TYPE,
    successType: CREATE_TICKET_TYPE_SUCCESS,
    errorType: CREATE_TICKET_TYPE_ERROR,
    route: `/graphql2`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        query: `
          mutation {
            create_ticket_type(ticket_type_params: ${formatDoubleQuotes({
              container_id: eventId,
              container_type: 'event',
              label: 'child',
              price: 0
            })}) {
              id
            }
          }
        `
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/actions/event.js